import axios from 'axios';
import CustomSelect from '../../components/form/custom-select';
import tplOffersList from './templates/offers-list.twig';
import {Utils} from '../../common/scripts/utils';

class OffersList {
    constructor() {
        /**
         * Обёртка
         */
        this.wrapper = null;

        /**
         * Адрес для запросов
         * @type {string}
         */
        this.action = '';

        /**
         * Обёртка для контента
         */
        this.contentWrappers = null;

        /**
         * Обёртка для списка
         */
        this.contentBlocks = [];

        /**
         * Подгружаем ли доп. новости, true - подгружаем, false - обновляем страницу
         * @type {boolean}
         */
        this.isLoadMore = false;

        /**
         * Класс который добавляется при подгрузке
         * @type {string}
         */
        this.loadingClass = 'is-loading';

        /**
         * Данные с сервера
         */
        this.data = null;
    }

    /**
     * Инициализация
     * @param {object} options - параметры
     */
    init(options) {
        this.wrapper = options.wrapper;

        this._getElements();
        this._initCustomSelect();
        this._bindEvents();
    }

    /**
     * Получает основные элементы со страницы
     * @private
     */
    _getElements() {
        this.action = this.wrapper.dataset.action;
        this.contentWrappers = Array.from(this.wrapper.querySelectorAll('.j-offers-list-wrapper'));

        this.contentWrappers.forEach((wrapper) => {
            const tagsWrapper = wrapper.querySelector('.j-offers-tags');
            let tags = null;
            let tagsHighlight = null;

            if (tagsWrapper) {
                tags = Array.from(tagsWrapper.querySelectorAll('.j-offers-tag'));
                tagsHighlight = tagsWrapper.querySelector('.j-offers-tags-highlight');

                this._changeHighlight(tagsHighlight, tags[0]);
            }

            const listWrapper = Array.from(wrapper.querySelectorAll('.j-offers-list'));
            const selectWrapper = wrapper.querySelector('.j-offers-select');
            const moreButton = wrapper.querySelector('.j-offers-more');
            const name = wrapper.dataset.tab;

            listWrapper.forEach((item) => {
                const isEmptyBlock = item.innerHTML.trim().length === 0;

                item.style.display = isEmptyBlock ? 'none' : 'flex';
            });

            const item = {
                listWrapper,
                tagsHighlight,
                tags,
                selectWrapper,
                moreButton,
                name
            };

            this.contentBlocks.push(item);
        });
    }

    /**
     * Инициализация кастомных селектов
     * @private
     */
    _initCustomSelect() {
        if (!this.contentBlocks.length) {
            return;
        }

        this.contentBlocks.forEach((block) => {
            if (!block.selectWrapper) {
                return;
            }

            const select = new CustomSelect({
                elem: block.selectWrapper
            });

            select.init();

            block.select = select;
        });
    }

    /**
     * Навешиваем обработчики событий
     * @private
     */
    _bindEvents() {
        if (!this.contentBlocks.length) {
            return;
        }

        this.contentBlocks.forEach((block) => {
            if (block.moreButton) {
                block.moreButton.addEventListener('click', () => {
                    if (block.moreButton.dataset.pageNum === '1') {
                        block.moreButton.setAttribute('data-page-num', '2');
                    }

                    this.isLoadMore = true;

                    this._send(block);
                });
            }

            if (block.selectWrapper) {
                this._bindEventsSelect(block.selectWrapper, block);
            }

            if (block.tags) {
                this._bindEventsTags(block.tags, block);
            }

            if (block.tagsHighlight) {
                const events = ['resize', 'orientationchange'];

                events.forEach((event) => {
                    window.addEventListener(event, () => {
                        const activeTag = block.tags.find((tag) => {
                            return tag.checked;
                        });

                        this._changeHighlight(block.tagsHighlight, activeTag);
                    });
                });
            }
        });
    }

    /**
     * Привязка событий к селекту
     * @param {object} select - обёртка селекта за которой следим
     * @param {object} block - обёртка контента
     * @private
     */
    _bindEventsSelect(select, block) {
        select.addEventListener('change', () => {
            if (block.moreButton) {
                block.moreButton.setAttribute('data-page-num', '1');
            }

            this.isLoadMore = false;

            this._send(block);
        });
    }

    /**
     * Навешивает обработчики событий на теги
     * @param {array} tags - массив тегов
     * @param {object} block - обёртка контента
     * @private
     */
    _bindEventsTags(tags, block) {
        if (!tags.length) {
            return;
        }

        tags.forEach((tag) => {
            tag.addEventListener('change', () => {
                if (block.moreButton) {
                    block.moreButton.setAttribute('data-page-num', '1');
                }

                if (block.tagsHighlight) {
                    this._changeHighlight(block.tagsHighlight, tag);
                }

                this.isLoadMore = false;

                this._send(block);
            });
        });
    }

    /**
     * Метод отправляет данные на сервер.
     * @param {object} container - данные по выбранному разделу
     * @private
     */
    async _send(container) {
        this.formData = this._collectData(container);

        this._toggleLoading(true);

        await axios.post(this.action, this.formData)
            .then((response) => {
                const success = response.data.success;

                if (success) {
                    this.data = response.data.data;

                    this._setTemplateData(container);
                } else {
                    throw new Error('Ошибка на сервере');
                }
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                this._toggleLoading(false);
            });
    }

    /**
     * Собирает данные для отправки
     * @param {object} container - данные по выбранному разделу
     * @return {FormData} - formData
     * @private
     */
    _collectData(container) {
        const formData = new FormData();
        const pageNum = container.moreButton ? container.moreButton.dataset.pageNum : '1';

        if (container.select) {
            const options = container.select.getOptions();

            const activeSelect = options.find((item) => {
                return item.checked;
            });

            formData.append('select', activeSelect.value);
        }

        if (container.tags) {
            container.tags.forEach((tag) => {
                if (!tag.checked) {
                    return;
                }

                formData.append('tags[]', tag.value);
            });
        }

        formData.append('page_num', pageNum);
        formData.append('type', container.name);

        return formData;
    }

    /**
     * Показывает/скрывает загрузку
     * @param {boolean} show - показать/скрыть
     * @private
     */
    _toggleLoading(show) {
        const method = show ? 'add' : 'remove';

        this.wrapper.classList[method](this.loadingClass);
    }

    /**
     * Устанавливает данные в шаблон
     * @param {object} container - данные по выбранному разделу
     * @private
     */
    _setTemplateData(container) {
        const {
            filters = null,
            page_num: pageNum = 2,
            more = false,
            items
        } = this.data;

        if (this.isLoadMore) {
            this._updatePage(container.listWrapper, items, false);
        } else {
            this._updatePage(container.listWrapper, items, true);
        }

        this._updateFilters(container, filters);
        this._updateMoreButton(container.moreButton, more, String(pageNum));
    }

    /**
     * Обновляет данные на странице
     * @param {object} container - контейнер куда выводим
     * @param {object} items - данные для вывода
     * @param {boolean} isClear - очищаем ли всё в контейнере
     * @private
     */
    _updatePage(container, items, isClear = true) {
        if (isClear) {
            container.forEach((wrapper) => {
                Utils.clearHtml(wrapper);
            });

            if (items.length < 5) {
                container[1].style.display = 'none';

                Utils.insetContent(container[0], tplOffersList({items}));
            } else {
                const firstPart = items.slice(0, 4);
                const secondPart = items.slice(4, items.length);

                container[1].style.display = 'flex';

                Utils.insetContent(container[0], tplOffersList({items: firstPart}));
                Utils.insetContent(container[1], tplOffersList({items: secondPart}));
            }
        } else {
            container[1].style.display = 'flex';

            Utils.insetContent(container[1], tplOffersList({items}));
        }

        // observer.publish('lazyLoad:refresh', container);
    }

    /**
     * Обновляет фильтр
     * @param {object} container - где обновляем
     * @param {object|null} filters - что обновляем
     * @private
     */
    _updateFilters(container, filters) {
        if (!filters) {
            return;
        }

        if (container.tags && filters.tags) {
            filters.tags.forEach((backendTag) => {
                const visibleTab = container.tags.find((tag) => {
                    return tag.value === backendTag.value;
                });

                if (!visibleTab) {
                    return;
                }

                visibleTab.checked = backendTag.checked || false;
                visibleTab.disabled = backendTag.disabled || false;
            });
        }

        if (container.select && filters.years) {
            filters.years.forEach((option) => {
                const input = container.selectWrapper.querySelector(`input[value="${option.value}"]`);

                if (!input) {
                    return;
                }

                input.disabled = option.disabled;
                input.checked = option.checked;
            });
        }
    }

    /**
     * Изменяем состояние кнопка "подгрузить ещё"
     * @param {object} moreButton - кнопка "подгрузить"
     * @param {object|boolean} more - информация о подгрузке
     * @param {string} pageNum - номер следующей страницы
     * @private
     */
    _updateMoreButton(moreButton, more, pageNum) {
        if (!moreButton) {
            return;
        }

        const method = more && more.more ? 'remove' : 'add';

        moreButton.classList[method]('is-hide');
        moreButton.innerText = more && more.text ? more.text : '';
        moreButton.setAttribute('data-page-num', pageNum);
    }

    /**
     * Смещение подстветки
     * @param {Node} highlight - нода подсветки
     * @param {Node} activeTag - активный тег
     * @private
     */
    _changeHighlight(highlight, activeTag) {
        if (!highlight || !activeTag) {
            return;
        }

        const activeTagWrapper = activeTag.parentNode.parentNode;
        const activeTagParent = activeTagWrapper.parentNode;

        const width = activeTagWrapper.offsetWidth;
        const coordsTab = activeTagWrapper.getBoundingClientRect();
        const coordsParent = activeTagParent.getBoundingClientRect();
        // Получаем данные о скролле родителя (актуально на мобилках)
        const parentHorizontalScrolled = activeTagParent.scrollLeft;


        highlight.style.width = `${width}px`;
        highlight.style.left = `${Math.abs(coordsParent.left - coordsTab.left) + parentHorizontalScrolled}px`;
    }
}

export default OffersList;
